import JSEncrypt from 'jsencrypt';
import api from './api';

let cachedPublicKey = null;

/**
 * Security Service
 * Handles client-side encryption for sensitive data
 */
export const securityService = {
  /**
   * Fetches the RSA Public Key from the backend
   * @returns {Promise<string>} The PEM encoded public key
   */
  async getPublicKey() {
    if (cachedPublicKey) return cachedPublicKey;

    try {
      const response = await api.get('/auth/public-key');
      // The backend should return the key in a field named 'publicKey'
      cachedPublicKey = response.publicKey || response.data?.publicKey || response;
      return cachedPublicKey;
    } catch (error) {
      console.error('Failed to fetch public key:', error);
      throw new Error('Could not establish secure connection to the server');
    }
  },

  /**
   * Encrypts a string using RSA Public Key
   * @param {string} plaintext - The data to encrypt
   * @returns {Promise<string>} The base64 encoded encrypted string
   */
  async encrypt(plaintext) {
    const publicKey = await this.getPublicKey();
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    
    const encrypted = encryptor.encrypt(plaintext);
    if (!encrypted) {
      throw new Error('Encryption failed');
    }
    
    return encrypted;
  }
};

export default securityService;
